import { ReduxAction } from '../../reducers/reducerType'
import { DialInType } from './dialInTypes'
import apiGateway from '../../../services/apiGateway'
import { StructuredPresenterInterface } from '../../selectors/structuredSelectPresenter/types'
import { DialInPhoneNumberRecord } from '../../../services/apiGateway/apiGatewayTypes'
import get from 'lodash/get'

export const fetchDialInCode = (roomname: string, participant: StructuredPresenterInterface) => async (dispatch) => {

  dispatch({ type: DialInType.FETCH_DIAL_IN_CODE })

  try {

    const response = await apiGateway.fetchDialInOptions(roomname, participant.name, participant.BTID)
    const { code } = response.data
    dispatch(fetchDialInCodeSuccess())
    dispatch(setParticipantCode(code))

  }
  catch (e) {

    dispatch(fetchDialInCodeError())

  }

}
export const fetchDialInCodeError = (): ReduxAction => ({ type: DialInType.FETCH_DIAL_IN_CODE_ERROR })
export const fetchDialInCodeSuccess = (): ReduxAction => ({ type: DialInType.FETCH_DIAL_IN_CODE_SUCCESS })
export const fetchDialInPhoneNumbers = (roomname: string) => async (dispatch) => {

  dispatch({ type: DialInType.FETCH_DIAL_IN_PHONE_NUMBERS })

  try {

    const response = await apiGateway.fetchDialInNumbers(roomname)
    const { phoneNumbers } = response.data

    dispatch(fetchDialInPhoneNumbersSuccess())
    dispatch(setDialInPhoneNumbers(phoneNumbers))

    if (phoneNumbers.length > 0) {

      const [ firstRecord ] = phoneNumbers
      if (!firstRecord) return
      dispatch(setSelectedPhoneNumber(firstRecord.phoneNumber))

    }

  }
  catch (e) {

    dispatch(fetchDialInPhoneNumbersError())

  }

}
export const fetchDialInPhoneNumbersError = (): ReduxAction => ({ type: DialInType.FETCH_DIAL_IN_PHONE_NUMBERS_ERROR })
export const fetchDialInPhoneNumbersSuccess = (): ReduxAction => ({ type: DialInType.FETCH_DIAL_IN_PHONE_NUMBERS_SUCCESS })
export const setDialInPhoneNumbers = (phoneNumbers: DialInPhoneNumberRecord[]): ReduxAction<DialInPhoneNumberRecord[]> => ({ type: DialInType.SET_DIAL_IN_PHONE_NUMBERS, payload: phoneNumbers })
export const setSelectedPhoneNumber = (selectedPhoneNumber: string) => ({ type: DialInType.SET_SELECTED_DIAL_IN_PHONE_NUMBER, payload: selectedPhoneNumber })
export const setParticipantCode = (code: number): ReduxAction<number> => ({ type: DialInType.SET_PARTICIPANT_CODE, payload: code })

export default {
  fetchDialInCode,
  fetchDialInCodeError,
  fetchDialInCodeSuccess,
  setParticipantCode,
  fetchDialInPhoneNumbers,
  fetchDialInPhoneNumbersError,
  fetchDialInPhoneNumbersSuccess,
  setDialInPhoneNumbers,
  setSelectedPhoneNumber
}
